import {Injectable} from '@angular/core';
import {DistributionCenter} from '@app/_models/api';
import {TableOptionsService} from '@app/_services/table-options.service';

@Injectable({
    providedIn: 'root'
})
export class DistributionCenterService extends TableOptionsService<DistributionCenter> {
    private _includeInactive = false;

    constructor() {
        super();
    }

    get includeInactive() {
        return this._includeInactive;
    }

    set includeInactive(includeInactive: boolean) {
        this._includeInactive = includeInactive;
        this.refreshDataSource();
    }

    public override matches(element: DistributionCenter, term: string) {
        if (!element.isActive && !this._includeInactive) {
            return false;
        }

        const lowerTerm = term.toLowerCase();
        return (
            element.tradingPartner.name.toLowerCase().includes(lowerTerm)
            || element.name.toLowerCase().includes(lowerTerm)
            || element.address1.toLowerCase().includes(lowerTerm)
            || element.identificationCodes.some(code => code.value.toLowerCase().includes(lowerTerm))
        );
    }
}
